import { ChangeDetectionStrategy, Component, OnInit, ViewChild, viewChild, ElementRef, OnDestroy, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import shajs from 'sha.js';
import { AuthService, LoginMethod } from '../../services/Auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/services/toast.service';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { catchError, finalize, first, firstValueFrom, interval, of, Subject } from 'rxjs';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import jwtDecode from 'jwt-decode';
import { APIService } from 'src/app/services/APIService/api.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { PopupRequest } from '@azure/msal-browser';
import { MsalConfigService, MsalTenantConfig } from 'src/app/services/msal-config.service';
import { ClarityModule, ClrForm } from '@clr/angular';
import { CommonModule } from '@angular/common';
import { CodeInputModule, CodeInputComponent } from 'angular-code-input';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'mrpro-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [CommonModule, ClarityModule, FormsModule, ReactiveFormsModule, MrTranslatePipe, CodeInputModule],
})
export class LoginComponent implements OnInit, OnDestroy {
  oktaAuth = inject<OktaAuth>(OKTA_AUTH);
  private authService = inject(AuthService);
  private msalConfigService = inject(MsalConfigService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private toastr = inject(ToastService);
  private mrTranslate = inject(MrTranslatePipe);
  private apiservice = inject(APIService);
  private domSanitizer = inject(DomSanitizer);

  loginGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    password: new UntypedFormControl('', [Validators.required]),
  });

  optPWkBuch: boolean = true;
  optPWgBuch: boolean = true;
  optPWZahl: boolean = true;
  optPWSonder: boolean = true;

  optPWMinL: number = 6;
  optAzkBuch: number = 1;
  optAzgBuch: number = 1;
  optAzZahl: number = 1;
  optAzSonder: number = 1;

  optPWExpire: String = '0';
  optPWExpireDays: number = 30;
  optPWHistoryCount: number = 0;
  optPWAdminMinL: number = 6;
  optAdminUsePW: boolean = false;
  optAdminMFA: boolean = false;
  checkAdminPWShowModal: boolean = false;
  googleCodeShow: boolean = false;

  protected passwordGroup: UntypedFormGroup = new UntypedFormGroup({
    opw: new UntypedFormControl('', [Validators.required]),
    npw: new UntypedFormControl('', [Validators.required]),
    npw1: new UntypedFormControl('', [Validators.required]),
  });

  changePasswordDB: string = '';
  changePassword: boolean = false;
  userName: string = '';
  isAuthenticated: boolean = false;
  error: Error | null = null;

  returnUrl: string;
  isDarkThemeAktiv = localStorage.getItem('theme') == 'dark';
  pemail: string;
  pcode: string;
  pw: string;
  pwsha: string;
  generatedNumber: number;
  userid: number;
  progressbarValue = 100;
  dateSec: string;
  curSec1: number = 0;
  _seconds: number = 0;
  tminutes: number = 0;
  tseconds: number = 0;
  doexittimer: boolean;
  dbs: any;
  dom: string;
  signIn: any;
  is2FA: boolean = false;
  mobil: string;
  private destroy$ = new Subject<void>();

  googleentrykey: string = '';
  googleqrimage: any;
  googleSetupShow: boolean = false;
  usegoogle: string = '0';
  correct: boolean = false;
  private readonly clrForm = viewChild(ClrForm);

  @ViewChild('excode') excode: ElementRef;
  @ViewChild('exmail') exmail: ElementRef;
  @ViewChild('exnewpw') exnewpw: ElementRef;
  @ViewChild('exnewpwconf') exnewpwconf: ElementRef;
  @ViewChild('seldb') seldb: ElementRef;
  @ViewChild('input', { static: false }) input: ElementRef;
  @ViewChild('codeInput') codeInput!: CodeInputComponent;
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isforgotPWModalVisible = false;
  isCodeModalVisible = false;
  isNewPasswordVisible = false;
  isRSVDatabaseSelectVisible = false;
  isTenentMailVisible = false;
  isFailedCodeVisible = false;
  msalEmail = '';
  isMsalConfigLoading = false;
  isMsalLoginInProgress = false;
  pendingMsalConfig: MsalTenantConfig | null = null;
  private isCompletingMsalLogin = false;
  name: string = '';
  showOktaLogin = environment.okta.showLogin;
  showMsalLogin = environment.msalConfig.showLogin;
  currentGeoLocation: any;
  codeColor = 'black';
  async ngOnInit() {
    if (this.isDarkThemeAktiv) this.codeColor = 'white';

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    this.dom = '2257f29edfa4372fe830a5d954e79bc56254472a91e75e0370da1abcc3497625';

    // Falls bereits eingeloggt (z.B. durch bestehenden JWT im localStorage), direkt weiterleiten
    if (this.authService.isLoggedIn()) {
      this.authService.setRoute();
    }
  }

  /**
   * Open the password reset modal
   */
  goToForgotPassword(): void {
    this.isforgotPWModalVisible = true;
  }

  timer2FAfinished: boolean = false;
  public timerInterval: any;

  timer2FA(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let statSec: number = 60;
    let textSec: any = '0';
    const prefix = minute < 10 ? '0' : '';

    this.timerInterval = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      console.log(`${prefix}${Math.floor(seconds / 60)}:${textSec}`);

      if (seconds == 0) {
        this.timer2FAfinished = true;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  do2FA($event) {
    if (this.excode.nativeElement.value.toString().length != 6) {
      this.toastr.error(this.mrTranslate.transform('Bestätigungscode ist ungültig'));
      return;
    }
    this.pcode = this.excode.nativeElement.value;
    if (this.pcode == this.generatedNumber.toString()) {
      this.is2FA = false;
      this.authService.handle2FALogin();
    } else {
      this.excode.nativeElement.value = '';
      this.toastr.error(this.mrTranslate.transform('Bestätigungscode ist ungültig'));
    }
  }

  do2FAsendSMS() {
    this.generatedNumber = Math.floor(100000 + Math.random() * 999999);
    this.authService.send2FASMS(this.mobil, this.generatedNumber.toString()).subscribe((data: any) => {
      if (data.success == true) {
        setTimeout(() => {
          clearInterval(this.timerInterval);
          this.is2FA = true;
          this.timer2FAfinished = false;
          this.timer2FA(1);
        }, 200);
      } else {
        this.authService.handle2FALogin();
      }
    });
  }

  doLoginIntern(event) {
    let karteFileID = JSON.parse(localStorage.getItem('karteFileID'));
    let db = this.seldb.nativeElement.value;

    let email = this.loginGroup.value.email;

    if (email.indexOf('@') < 0) {
      this.toastr.error(this.mrTranslate.transform('Geben Sie bitte eine gültige EMail Adresse ein.'));
      return;
    }
    if (db.includes('REP||')) {
      if (db.split('||')[4] === 'False') this.toastr.info(this.mrTranslate.transform('Replikat wird erstellt...'));
    }

    let pwhash = shajs('sha256').update(this.loginGroup.value.password).digest('hex');
    this.authService.login(email, pwhash, db, karteFileID).subscribe(
      (data: any) => {
        if (data == true) {
          if (this.authService.twofa.value == 1) {
            let token = jwtDecode(this.authService.tempdata.token);
            this.mobil = token['mobil'];
            this.isRSVDatabaseSelectVisible = false;

            if (this.mobil == 'rsvintern') {
              this.authService.handle2FALogin();
              this.toastr.success(this.mrTranslate.transform('Erfolgreich eingeloggt'));
              return;
            }

            if (this.mobil == '') {
              this.toastr.error(
                this.mrTranslate.transform(
                  'Ein Anmeldung ist nicht möglich. Für die 2 Faktor Authentifizierung fehlt die Mobilnummer in Ihrem Account. Bitte wenden Sie sich an Ihren Administrator.'
                )
              );
            } else {
              this.do2FAsendSMS();
            }

            return;
          }

          if (this.authService.twofa.value == 2) {
            this.isRSVDatabaseSelectVisible = false;

            let token = jwtDecode(this.authService.tempdata.token);
            let items = {
              email: token['email'],
              db: token['db'],
            };

            if (!this.authService.tempdata.mfaaktiv) {
              this.googleSetupShow = false;

              this.apiservice.setupGoogleCode(items, this.authService.tempdata.token).subscribe((data: any) => {
                if (data) {
                  if (data.error != undefined) {
                    this.toastr.error(this.mrTranslate.transform(data.error));
                    return;
                  } else {
                    this.googleentrykey = data.ManualEntryKey;
                    this.googleqrimage = this.domSanitizer.bypassSecurityTrustUrl(data.qrCodeSetupImageUrl);
                    this.googleSetupShow = true;
                    setTimeout(() => {
                      this.codeInput.focusOnField(0);
                    }, 20);
                  }
                } else {
                  this.toastr.error(this.mrTranslate.transform('Es ist ein Fehler aufgetreten.'));
                  return;
                }
              });
            } else {
              this.openGoogle();
            }
            return;
          }

          this.toastr.success(this.mrTranslate.transform('Erfolgreich eingeloggt'));

        } else {
          if (data.info != undefined) {
            if (data.info != '') {
              this.toastr.info(this.mrTranslate.transform(data.info));
              this.isRSVDatabaseSelectVisible = false;

              if (data.pwreset != undefined) {
                if (data.pwreset === true) {
                  this.changePasswordDB = data.db;
                  this.initSettings(data.sysini);

                  setTimeout(() => {
                    this.changePassword = true;
                  }, 1500);
                }
              }

              return;
            }
          }

          if (data.error != undefined) {
            if (data?.error == 'Server is not available' || data?.error?.type == 'error') {
              this.toastr.info(
                this.mrTranslate.transform(
                  'MR.pro® ist zur Zeit leider nicht erreichbar. Wir sind mit der Lösung des Problems beschäftigt. Bitte versuchen sie es später noch einmal.'
                )
              );
            } else {
              this.toastr.error(this.mrTranslate.transform('Login fehlgeschlagen'));
            }
          }
        }

        this.isRSVDatabaseSelectVisible = false;
      },
      (_: HttpErrorResponse) => {}
    );
  }

  async msalLogin() {
    localStorage.removeItem('msal');
    this.resetPendingMsalLogin();
    this.isTenentMailVisible = true;
  }

  async doMSALLogin(msal: MsalTenantConfig, loginHintEmail?: string): Promise<boolean> {
    if (this.isMsalLoginInProgress) {
      return false;
    }

    this.isMsalLoginInProgress = true;
    try {
      console.log('[MSAL] Starting MSAL login flow', {
        tenantId: msal.tenid,
        appId: msal.appid,
        db: msal.db,
        loginHint: loginHintEmail,
      });
      const instance =
        this.msalConfigService.getCurrentInstance() ?? (await this.msalConfigService.setConfig(msal.tenid, msal.appid));
      console.log('[MSAL] MSAL instance ready');

      // Ensure interaction is removed! That can happen when we log out or when an error occurs during login
      sessionStorage.removeItem('msal.interaction.status');

      // TODO: Aktuell müssen wir das mit Popup machen, weil wir in Azure glaube ich keine Root Domain wie http://localhost:4201/ oder https://dev.mrpro.cloud/ eintragen können. Ist aber auch nicht verkehrt? :)
      console.log('[MSAL] Opening login popup...');
      const popupRequest: PopupRequest = {
        scopes: ['openid', 'profile', 'email'],
        redirectUri: this.msalConfigService.getRedirectUri(),
        // prompt: 'login' erzwingt Passwort-Eingabe, verhindert stilles SSO über
        // Microsoft-Domain-Cookies, WAM (Windows Account Manager) oder OS-Account
        prompt: 'login',
      };
      // loginHint überspringt die E-Mail-Eingabe im Microsoft-Popup und zeigt direkt das Passwort-Feld
      if (loginHintEmail) {
        popupRequest.loginHint = loginHintEmail;
      }
      const authenticationResult = await instance.loginPopup(popupRequest);

      console.log('[MSAL] Popup login completed', {
        account: authenticationResult.account?.username,
        tenantId: authenticationResult.account?.tenantId,
        hasIdToken: !!authenticationResult.idToken,
        scopes: authenticationResult.scopes,
      });

      instance.setActiveAccount(authenticationResult.account);

      const email = authenticationResult.account?.username;
      const idToken = authenticationResult.idToken;

      if (!email || !idToken) {
        console.error('[MSAL] Missing email or idToken after popup login', {
          email,
          hasIdToken: !!idToken,
        });
        await this.msalConfigService.clearMsalCache();
        this.toastr.error(this.mrTranslate.transform('Login fehlgeschlagen: Kein gültiges Token erhalten.'));
        return false;
      }

      console.log('[MSAL] Sending idToken to backend for validation', { email });
      const result = await firstValueFrom(this.authService.msalLogin(email, idToken));
      console.log('[MSAL] Backend response:', result);

      if (result?.error) {
        console.error('[MSAL] Backend returned error:', result.error, result.info || '');
        await this.msalConfigService.clearMsalCache();
        this.toastr.error(this.mrTranslate.transform(this.getMsalBackendErrorMessage(result)));
        return false;
      }

      this.msalConfigService.persistConfig({ ...msal, email });
      console.log('[MSAL] Login successful, navigating to /');
      this.authService.loginMethod = LoginMethod.Microsoft;
      localStorage.setItem('loginMethod', 'Microsoft');
      this.isCompletingMsalLogin = true;
      this.isTenentMailVisible = false;
      this.resetPendingMsalLogin();
      this.router.navigateByUrl('/');
      return true;
    } catch (loginError) {
      console.warn('[MSAL] Interactive login failed', loginError);
      await this.logMsalFrontendError('interactive-login', loginError, msal, loginHintEmail);
      await this.msalConfigService.clearMsalCache();
      this.msalConfigService.clearRuntimeConfig();
      localStorage.removeItem('msal');
      this.isCompletingMsalLogin = false;
      this.isTenentMailVisible = false;
      this.resetPendingMsalLogin();

      if (this.isMsalUserCancellation(loginError)) {
        this.toastr.info(this.mrTranslate.transform('Anmeldung abgebrochen.'));
      } else {
        this.toastr.error(this.mrTranslate.transform(this.getMsalLoginErrorMessage(loginError)));
      }

      return false;
    } finally {
      this.isMsalLoginInProgress = false;
    }
  }

  async getMSALMail(): Promise<void> {
    if (this.pendingMsalConfig) {
      await this.doMSALLogin(this.pendingMsalConfig, this.pemail);
      return;
    }

    await this.resolveMsalConfig(this.msalEmail);
  }

  onMsalEmailChange(email: string): void {
    this.msalEmail = email;
    this.pendingMsalConfig = null;
    this.msalConfigService.clearRuntimeConfig();
  }

  closeMsalTenantModal(): void {
    this.isTenentMailVisible = false;
    this.isCompletingMsalLogin = false;
    this.resetPendingMsalLogin();
    this.msalConfigService.clearRuntimeConfig();
    localStorage.removeItem('msal');
  }

  handleMsalTenantModalOpenChange(isOpen: boolean): void {
    this.isTenentMailVisible = isOpen;

    if (!isOpen) {
      if (this.isCompletingMsalLogin) {
        this.isCompletingMsalLogin = false;
        return;
      }

      this.resetPendingMsalLogin();
      this.msalConfigService.clearRuntimeConfig();
      localStorage.removeItem('msal');
    }
  }

  private async resolveMsalConfig(email: string): Promise<void> {
    this.pemail = email?.trim();

    if (!this.pemail || this.pemail.indexOf('@') < 0) {
      this.toastr.error(this.mrTranslate.transform('Geben Sie eine gültige Email Adresse ein'));
      return;
    }

    this.isMsalConfigLoading = true;

    try {
      console.log('[MSAL] Fetching tenant config for email:', this.pemail);
      const data: any = await firstValueFrom(this.apiservice.getnewTenantId(this.pemail));

      if (data.error) {
        await this.logMsalFrontendError('tenant-config-response', new Error(data.error), undefined, this.pemail);
        this.toastr.error(this.mrTranslate.transform(data.error));
        return;
      }

      const appId = data?.ADAppid?.trim();
      const tenantId = data?.ADTenant?.trim();

      if (!appId || !tenantId) {
        this.toastr.error(
          this.mrTranslate.transform('Es ist im System keine Konfiguration für Entra ID/Azure AD hinterlegt.')
        );
        return;
      }

      const msal: MsalTenantConfig = {
        appid: appId,
        tenid: tenantId,
      };

      await this.msalConfigService.setConfig(msal.tenid, msal.appid);
      this.apiservice.aud = msal.appid;
      this.apiservice.tid = msal.tenid;
      this.pendingMsalConfig = msal;
    } catch (apiError) {
      console.error('API call failed', apiError);
      this.toastr.error(this.mrTranslate.transform('Fehler beim Abrufen der Azure/Entra-Konfiguration.'));
      this.apiservice
        .logError(apiError)
        .pipe(
          catchError(err => {
            console.error('Failed to log error', err);
            return of(null);
          }),
          finalize(() => {})
        )
        .subscribe();
    } finally {
      this.isMsalConfigLoading = false;
    }
  }

  private resetPendingMsalLogin(): void {
    this.msalEmail = '';
    this.pemail = '';
    this.isMsalConfigLoading = false;
    this.pendingMsalConfig = null;
  }

  private isMsalUserCancellation(error: unknown): boolean {
    const errorCode = ((error as any)?.errorCode || (error as any)?.code || '').toString().toLowerCase();
    const errorMessage = error instanceof Error ? error.message.toLowerCase() : JSON.stringify(error).toLowerCase();

    return errorCode === 'user_cancelled' || errorMessage.includes('user_cancelled');
  }

  private getMsalLoginErrorMessage(error: unknown): string {
    const errorCode = ((error as any)?.errorCode || (error as any)?.code || '').toString().toLowerCase();
    const errorMessage = error instanceof Error ? error.message.toLowerCase() : JSON.stringify(error).toLowerCase();
    const combined = `${errorCode} ${errorMessage}`;

    // AADSTS9002326: Die interaktive Anmeldung gelingt (Entra Sign-in-Log = erfolgreich), nur das
    // Einlösen des Codes gegen ein Token schlägt fehl, weil die Redirect-URI als Plattform "Web"
    // statt "Single-page application" registriert ist. Muss vor der Client-ID-Prüfung stehen, weil
    // die Meldung "client-type" enthält.
    if (
      combined.includes('aadsts9002326') ||
      combined.includes('cross-origin token redemption') ||
      combined.includes('single-page application')
    ) {
      return 'Anmeldung bei Microsoft fehlgeschlagen: Die Redirect-URI muss in der Entra App Registration als Plattform "Single-page application" registriert sein.';
    }

    if (combined.includes('aadsts50011') || combined.includes('redirect') || combined.includes('reply url')) {
      return 'Anmeldung bei Microsoft fehlgeschlagen: Die Redirect-URI ist in der Entra App Registration nicht korrekt hinterlegt.';
    }

    if (combined.includes('aadsts700016') || combined.includes('invalid_client') || combined.includes('client')) {
      return 'Anmeldung bei Microsoft fehlgeschlagen: Die hinterlegte App ID/Client ID ist ungültig oder nicht im Tenant vorhanden.';
    }

    if (combined.includes('aadsts90002') || combined.includes('tenant')) {
      return 'Anmeldung bei Microsoft fehlgeschlagen: Die hinterlegte Tenant ID oder Tenant-Domäne ist ungültig.';
    }

    if (combined.includes('example.com')) {
      return 'Anmeldung bei Microsoft fehlgeschlagen: Die MSAL-Konfiguration enthält noch einen Platzhalter wie example.com.';
    }

    return 'Anmeldung bei Microsoft Azure/Entra ist fehlgeschlagen.';
  }

  private getMsalBackendErrorMessage(result: any): string {
    const combined = `${result?.error ?? ''} ${result?.info ?? ''}`.toLowerCase();

    if (combined.includes('audience') || combined.includes('aud') || combined.includes('client') || combined.includes('appid')) {
      return 'Login fehlgeschlagen: Das Microsoft-Token passt nicht zur hinterlegten App ID/Client ID.';
    }

    if (combined.includes('issuer') || combined.includes('tenant') || combined.includes('tid')) {
      return 'Login fehlgeschlagen: Das Microsoft-Token passt nicht zur hinterlegten Tenant ID.';
    }

    if (combined.includes('signature') || combined.includes('signing') || combined.includes('key')) {
      return 'Login fehlgeschlagen: Das Microsoft-Token konnte nicht gegen die Microsoft-Signatur geprüft werden.';
    }

    if (combined.includes('expired') || combined.includes('lifetime')) {
      return 'Login fehlgeschlagen: Das Microsoft-Token ist abgelaufen. Bitte erneut anmelden.';
    }

    return 'Login fehlgeschlagen';
  }

  private async logMsalFrontendError(
    context: string,
    error: unknown,
    msalConfig?: { appid?: string; tenid?: string; db?: any },
    loginHint?: string
  ): Promise<void> {
    const errorMessage = error instanceof Error ? error.message : JSON.stringify(error);
    const payload = {
      context: `msal-${context}`,
      message: errorMessage,
      tenantId: msalConfig?.tenid || null,
      appId: msalConfig?.appid || null,
      db: msalConfig?.db || null,
      loginHint: loginHint || null,
      path: this.router.url,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
      timestamp: new Date().toISOString(),
    };

    await firstValueFrom(
      this.apiservice.logError(payload).pipe(
        catchError(err => {
          console.error('Failed to log MSAL frontend error', err);
          return of(null);
        })
      )
    );
  }

  async oktaLogin() {
    try {
      const force = sessionStorage.getItem('oktaForceLogin') === 'true';
      const params: any = {
        scopes: ['openid', 'profile', 'email', 'groups-mrpro'],
        authorizationParams: {},
      };

      if (force) {
        // Extra hardening: clear existing local Okta tokens before redirect
        try {
          await (this.oktaAuth as any).tokenManager.clear();
        } catch {}
        try {
          await (this.oktaAuth as any).revokeAccessToken();
        } catch {}
        try {
          await (this.oktaAuth as any).revokeIdToken();
        } catch {}
        // Force re-authentication even if an SSO session exists
        params.authorizationParams.prompt = 'login';
        params.authorizationParams.max_age = 0;
        params.authorizationParams.sessionToken = undefined; // ensure no one-time token bypass
        // Remove flag only AFTER setting params to guarantee one forced cycle
        sessionStorage.removeItem('oktaForceLogin');
      }

      await this.oktaAuth.signInWithRedirect(params);
    } catch (error) {
      console.error('Okta login failed:', error);
      this.toastr.error(this.mrTranslate.transform('Okta Anmeldung fehlgeschlagen'));
    }
  }

  doLogin(event) {
    if (event?.preventDefault) {
      event.preventDefault();
    }
    if (event?.stopPropagation) {
      event.stopPropagation();
    }

    let karteFileID = JSON.parse(localStorage.getItem('karteFileID'));
    if (karteFileID == null) karteFileID = '1';

    let email = this.loginGroup.value.email;

    if (email.indexOf('@') < 0) {
      this.toastr.error(this.mrTranslate.transform('Geben Sie bitte eine gültige EMail Adresse ein.'));
      return;
    }
    let pwhash = shajs('sha256').update(this.loginGroup.value.password).digest('hex');

    if (
      shajs('sha256')
        .update(email.substring(email.indexOf('@') + 1, 100))
        .digest('hex') == this.dom
    ) {
      this.authService
        .internlogin(
          email,
          pwhash,
          shajs('sha256')
            .update(email.substring(email.indexOf('@') + 1, 100))
            .digest('hex'),
          karteFileID
        )
        .subscribe(
          (data: any) => {
            if (data.check == true) {
              this.dbs = data.allDB.rows;

              if (this.dbs != undefined) {
                setTimeout(() => {
                  this.isRSVDatabaseSelectVisible = true;
                }, 200);
              } else {
                if (data.info != undefined) {
                  if (data.info != '') {
                    this.toastr.info(this.mrTranslate.transform(data.info));
                    this.isRSVDatabaseSelectVisible = false;
                    return;
                  }
                }
                if (data?.error == 'Server is not available' || data?.error?.type == 'error') {
                  this.toastr.info(
                    this.mrTranslate.transform(
                      'MR.pro® ist zur Zeit leider nicht erreichbar. Wir sind mit der Lösung des Problems beschäftigt. Bitte versuchen sie es später noch einmal.'
                    )
                  );
                } else {
                  this.toastr.error(this.mrTranslate.transform('Login fehlgeschlagen'));
                }
              }
            } else {
              if (data.info != undefined) {
                if (data.info != '') {
                  this.toastr.info(this.mrTranslate.transform(data.info));
                  this.isRSVDatabaseSelectVisible = false;
                  return;
                }
              }
              if (data?.error == 'Server is not available' || data?.error?.type == 'error') {
                this.toastr.info(
                  this.mrTranslate.transform(
                    'MR.pro® ist zur Zeit leider nicht erreichbar. Wir sind mit der Lösung des Problems beschäftigt. Bitte versuchen sie es später noch einmal.'
                  )
                );
              } else {
                this.toastr.error(this.mrTranslate.transform('Login fehlgeschlagen'));
              }
            }
          },
          (error: HttpErrorResponse) => {}
        );
    } else {
      this.authService.loginGetDatabases(email, pwhash).subscribe((data: any) => {
        if (data.check == true) {
          this.dbs = data.allDB.rows;

          if (this.dbs != undefined) {
            setTimeout(() => {
              this.isRSVDatabaseSelectVisible = true;
            }, 200);
          } else {
            this.login();
          }
        } else {
          this.login();
        }
      });
    }
  }

  verifyLoginFailedCode() {
    if (this.input.nativeElement.value.toString().length != 6) {
      this.toastr.error(this.mrTranslate.transform('Bestätigungscode ist ungültig'));
      return;
    }

    let items = {
      code: this.input.nativeElement.value,
      email: this.loginGroup.value.email,
    };

    this.apiservice.verifyLoginFailedCode(items).subscribe((data: any) => {
      if (data) {
        if (data.error != undefined) {
          this.toastr.error(this.mrTranslate.transform(data.error));
          return;
        } else {
          if (data.success) {
            this.input.nativeElement.value = '';
            this.isFailedCodeVisible = false;
            this.toastr.success(this.mrTranslate.transform('Sicherheitsüberprüfung war erfolgreich'));

            if (this.correct) {
              setTimeout(() => {
                this.doLogin(undefined);
              }, 150);
            }
          } else {
            this.toastr.error(this.mrTranslate.transform('Code ist ungültig'));

            this.input.nativeElement.value = '';
            setTimeout(() => {
              this.input.nativeElement.focus();
            }, 20);

            return;
          }
        }
      } else {
        this.toastr.error(this.mrTranslate.transform('Es ist ein Fehler aufgetreten.'));
        return;
      }
    });
  }

  onCodeCompletedSave(code: string) {
    this.verifyGoogleCode(code, true);
  }

  onCodeCompleted(code: string) {
    this.verifyGoogleCode(code, false);
  }

  verifyGoogleCodes() {
    this.verifyGoogleCode(this.codeInput!.code!.toString(), false);
  }

  verifyGoogleCode(code: string, save: boolean) {
    if (code.length != 6) {
      this.toastr.error(this.mrTranslate.transform('Bestätigungscode ist ungültig'));
      return;
    }

    let token = jwtDecode(this.authService.tempdata.token);
    let items = {
      code: code,
      email: token['email'],
      db: token['db'],
    };

    this.apiservice.verifyGoogleCode(items, this.authService.tempdata.token).subscribe((data: any) => {
      if (data) {
        if (data.error != undefined) {
          this.toastr.error(this.mrTranslate.transform(data.error));
          return;
        } else {
          if (data.success) {
            this.googleSetupShow = false;
            this.authService.handle2FALogin();

            if (save) {
              setTimeout(() => {
                let items = {
                  id: token['id'],
                  email: token['email'],
                  mfaaktiv: true,
                };
                this.apiservice.saveGoogleCode(items).subscribe((data: any) => {});
              }, 1500);
            }
          } else {
            this.toastr.error(this.mrTranslate.transform('Code ist ungültig'));

            this.codeInput.reset();
            setTimeout(() => {
              this.codeInput.focusOnField(0);
            }, 20);

            return;
          }
        }
      } else {
        this.toastr.error(this.mrTranslate.transform('Es ist ein Fehler aufgetreten.'));
        return;
      }
    });
  }

  openGoogle() {
    this.googleCodeShow = true;

    setTimeout(() => {
      this.codeInput.focusOnField(0);
    }, 50);
  }

  restGoogleCode() {
    this.googleCodeShow = false;
    let token = jwtDecode(this.authService.tempdata.token);
    let items = {
      email: token['email'],
      db: token['db'],
    };

    this.apiservice.setupGoogleCode(items, this.authService.tempdata.token).subscribe((data: any) => {
      if (data) {
        if (data.error != undefined) {
          this.toastr.error(this.mrTranslate.transform(data.error));
          return;
        } else {
          this.googleentrykey = data.ManualEntryKey;
          this.googleqrimage = this.domSanitizer.bypassSecurityTrustUrl(data.qrCodeSetupImageUrl);
          this.googleSetupShow = true;
          setTimeout(() => {
            this.codeInput.focusOnField(0);
          }, 20);
        }
      } else {
        this.toastr.error(this.mrTranslate.transform('Es ist ein Fehler aufgetreten.'));
        return;
      }
    });
  }

  login() {
    this.correct = false;
    let email = this.loginGroup.value.email;

    if (email.indexOf('@') < 0) {
      this.toastr.error(this.mrTranslate.transform('Geben Sie bitte eine gültige EMail Adresse ein.'));
      return;
    }

    let pwhash = shajs('sha256').update(this.loginGroup.value.password).digest('hex');
    let karteFileID = JSON.parse(localStorage.getItem('karteFileID'));
    this.authService.login(email, pwhash, undefined, karteFileID).subscribe(
      (data: any) => {
        if (data == true) {
          if (this.authService.twofa.value == 1) {
            let token = jwtDecode(this.authService.tempdata.token);
            this.mobil = token['mobil'];
            this.isRSVDatabaseSelectVisible = false;

            if (this.mobil == '') {
              this.toastr.error(
                this.mrTranslate.transform(
                  'Ein Anmeldung ist nicht möglich. Für die 2 Faktor Authentifizierung fehlt die Mobilnummer in Ihrem Account. Bitte wenden Sie sich an Ihren Administrator.'
                )
              );
            } else {
              this.do2FAsendSMS();
            }

            return;
          }
          if (this.authService.twofa.value == 2) {
            let token = jwtDecode(this.authService.tempdata.token);

            let items = {
              email: token['email'],
              db: token['db'],
            };

            if (!this.authService.tempdata.mfaaktiv) {
              this.googleSetupShow = false;

              this.apiservice.setupGoogleCode(items, this.authService.tempdata.token).subscribe((data: any) => {
                if (data) {
                  if (data.error != undefined) {
                    this.toastr.error(this.mrTranslate.transform(data.error));
                    return;
                  } else {
                    this.googleentrykey = data.ManualEntryKey;
                    this.googleqrimage = this.domSanitizer.bypassSecurityTrustUrl(data.qrCodeSetupImageUrl);
                    this.googleSetupShow = true;
                    setTimeout(() => {
                      this.codeInput.focusOnField(0);
                    }, 20);
                  }
                } else {
                  this.toastr.error(this.mrTranslate.transform('Es ist ein Fehler aufgetreten.'));
                  return;
                }
              });
            } else {
              this.openGoogle();
            }
            return;
          }

          this.toastr.success(this.mrTranslate.transform('Erfolgreich eingeloggt'));
        } else {
          if (data.info != undefined) {
            if (data.info != '') {
              this.toastr.warning(this.mrTranslate.transform(data.info), this.mrTranslate.transform('INFO'), {
                positionClass: 'toast-center-screen',
              });

              this.isRSVDatabaseSelectVisible = false;

              if (data.pwreset != undefined) {
                if (data.pwreset) {
                  this.changePasswordDB = data.db;
                  this.initSettings(data.sysini);

                  setTimeout(() => {
                    this.changePassword = true;
                  }, 1500);
                }
              }
              return;
            }
          }
          if (data?.error == 'Server is not available' || data?.error?.type == 'error') {
            this.toastr.info(
              this.mrTranslate.transform(
                'MR.pro® ist zur Zeit leider nicht erreichbar. Wir sind mit der Lösung des Problems beschäftigt. Bitte versuchen sie es später noch einmal.'
              )
            );
          } else {
            if (data.failed) {
              if (data.failed > 1000) {
                this.pcode = data.failed;
                this.name = data.name ? data.name : '';
                this.correct = data.correct;
                this.isFailedCodeVisible = true;

                setTimeout(() => {
                  this.input.nativeElement.focus();
                }, 50);
              } else if (data.failed == 3) {
                let errortext = this.mrTranslate.transform('Die Passworteingabe ist zum 3. Mal gescheitert.') + '</br>';
                errortext +=
                  this.mrTranslate.transform('Noch zwei Versuche, dann wird ihre Anmeldung gesperrt.') + '</br>';
                this.toastr.error(
                  this.mrTranslate.transform(errortext),
                  this.mrTranslate.transform('Login fehlgeschlagen'),
                  {
                    enableHtml: true,
                    closeButton: true,
                    tapToDismiss: false,
                    timeOut: 20000,
                    positionClass: 'toast-center-center',
                  }
                );
              } else if (data.failed == 4) {
                let errortext = this.mrTranslate.transform('Die Passworteingabe ist zum 4. Mal gescheitert.') + '</br>';
                errortext +=
                  this.mrTranslate.transform('Noch ein Versuch, dann wird ihre Anmeldung gesperrt.') + '</br>';
                this.toastr.error(
                  this.mrTranslate.transform(errortext),
                  this.mrTranslate.transform('Login fehlgeschlagen'),
                  {
                    enableHtml: true,
                    closeButton: true,
                    tapToDismiss: false,
                    timeOut: 20000,
                    positionClass: 'toast-center-center',
                  }
                );
              } else {
                this.toastr.error(this.mrTranslate.transform('Login fehlgeschlagen'));
              }
            } else {
              this.toastr.error(this.mrTranslate.transform('Login fehlgeschlagen'));
            }
          }
        }
      },
      (error: HttpErrorResponse) => {}
    );
  }

  validatePassword(pw: string) {
    let errortext = this.mrTranslate.transform('Das Passwort entspricht nicht den Sicherheitsrichtlinien') + ':</br>';
    errortext += this.mrTranslate.transform('Anzahl Zeichen') + ': ' + this.optPWMinL.toString() + '</br>';

    if (this.optPWkBuch) {
      errortext += this.mrTranslate.transform('Anzahl Kleinbuchstaben') + ': ' + this.optAzkBuch.toString() + '</br>';
    }
    if (this.optPWgBuch) {
      errortext += this.mrTranslate.transform('Anzahl Grossbuchstaben') + ': ' + this.optAzgBuch.toString() + '</br>';
    }
    if (this.optPWSonder) {
      errortext += this.mrTranslate.transform('Anzahl Sonderzeichen') + ': ' + this.optAzSonder.toString() + '</br>';
    }

    if (pw == undefined) {
      if (this.authService.token.rights.showusers == true) {
        return errortext;
      } else {
        return errortext;
      }
    }

    if (pw == '') {
      if (this.authService.token.rights.showusers == true) {
        return errortext;
      } else {
        return errortext;
      }
    }

    let hasNumber = new RegExp('[0-9]');
    let hasUpperChar = new RegExp('[A-Z]');
    let hasLowerChar = new RegExp('[a-z]');
    let hasSymbols = new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/);
    let countUpper: number = 0;
    let countLower: number = 0;
    let countNumber: number = 0;
    let countSymbols: number = 0;

    if (pw.length < this.optPWMinL) {
      return errortext;
    }

    if (this.optPWkBuch) {
      if (!pw.match(/[a-z]/)) {
        return errortext;
      }
      countLower = (pw.match(/[a-z]/g) || []).length;
      if (this.optAzkBuch > countLower) {
        return errortext;
      }
    }

    if (this.optPWgBuch) {
      if (!pw.match(/[A-Z]/)) {
        return errortext;
      }
      countUpper = (pw.match(/[A-Z]/g) || []).length;
      if (this.optAzgBuch > countUpper) {
        return errortext;
      }
    }

    if (this.optPWZahl) {
      if (!pw.match(/[0-9]/)) {
        return errortext;
      }
      countNumber = (pw.match(/[0-9]/g) || []).length;
      if (this.optAzZahl > countNumber) {
        return errortext;
      }
    }

    if (this.optPWSonder) {
      if (!pw.match(hasSymbols)) {
        return errortext;
      }
      try {
        countSymbols = pw.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g).length;
        if (this.optAzSonder > countSymbols) {
          return errortext;
        }
      } catch (e) {
        return errortext;
      }
    }

    return '';
  }

  ResetRequiredPassword(): void {
    this.clrForm().markAsTouched();
    if (this.passwordGroup.valid) {
      let opw = this.passwordGroup.value.opw;
      let npw = this.passwordGroup.value.npw;
      let npw1 = this.passwordGroup.value.npw1;

      if (opw == npw) {
        this.toastr.info(
          this.mrTranslate.transform(
            'Altes und neues Passwort ist gleich. Passwort wurde nicht geändert, bitte ändern Sie Ihre Eingabe.'
          )
        );
        return;
      }

      if (npw != npw1) {
        this.toastr.error(
          this.mrTranslate.transform('Passwort und Wiederholung stimmen nicht überein, bitte ändern Sie Ihre Eingabe.')
        );
        return;
      }

      let validPW = this.validatePassword(npw);
      if (validPW != '') {
        this.toastr.error(this.mrTranslate.transform(validPW), '', {
          enableHtml: true,
        });
        return;
      }

      let pwhash_old = shajs('sha256').update(opw).digest('hex');
      let pwhash_new = shajs('sha256').update(npw).digest('hex');

      let editUser = {
        status: 'resetrequiredpassword',
        pwhas: pwhash_old,
        pwhash_new: pwhash_new,
        email: this.loginGroup.value.email,
        db: this.changePasswordDB,
      };

      this.apiservice
        .restPWUser(editUser)
        .pipe(first())
        .subscribe((val: any) => {
          if (val.message.toLowerCase() === 'ok') {
            this.toastr.success(this.mrTranslate.transform('Passwort wurde erfolgreich geändert…'));
            this.changePassword = false;

            this.passwordGroup.value.opw = '';
            this.passwordGroup.value.npw = '';
            this.passwordGroup.value.npw1 = '';

            setTimeout(() => {
              this.loginGroup.controls.password.setValue(npw);
              this.login();
            }, 500);
          } else {
            if (val.text) {
              this.toastr.error(this.mrTranslate.transform(val.text));
            } else {
              this.toastr.error(this.mrTranslate.transform('Leider ist ein Fehler aufgetreten.'));
            }
          }
        });
    }
  }

  initSettings(val: any) {
    if (!val) return;
    this.optPWkBuch = val.optPWkBuch;
    this.optPWgBuch = val.optPWgBuch;
    this.optPWZahl = val.optPWZahl;
    this.optPWSonder = val.optPWSonder;
    this.optPWMinL = val.optPWMinL;
    this.optAzkBuch = val.optAzkBuch;
    this.optAzgBuch = val.optAzgBuch;
    this.optAzZahl = val.optAzZahl;
    this.optAzSonder = val.optAzSonder;
    this.optPWExpire = val.optPWExpire;
    this.optPWExpireDays = val.optPWExpireDays;
    this.optPWHistoryCount = val.optPWHistoryCount;
    this.optPWAdminMinL = val.optPWAdminMinL;
    this.optAdminUsePW = val.optAdminUsePW;
    this.optAdminMFA = val.optAdminMFA;
  }

  getMail(event): void {
    if (this.exnewpw != undefined) this.exnewpw.nativeElement.value = '';

    if (this.exnewpwconf != undefined) this.exnewpwconf.nativeElement.value = '';

    this.pemail = this.exmail.nativeElement.value;

    if (this.pemail == '') {
      this.isforgotPWModalVisible = true;
      this.toastr.error(this.mrTranslate.transform('Geben Sie eine gültige Email Adresse ein'));
    } else {
      // Use new secure password reset flow
      this.authService.sendforgotemail(this.pemail, '').subscribe(
        (response: any) => {
          // Always show success message (security best practice - don't reveal if email exists)
          this.exmail.nativeElement.value = '';
          this.isforgotPWModalVisible = false;

          this.toastr.success(
            this.mrTranslate.transform(
              'Wenn ein Konto mit dieser E-Mail-Adresse existiert, wurde eine E-Mail mit Anweisungen zum Zurücksetzen des Passworts gesendet.'
            ),
            '',
            { timeOut: 8000 }
          );
        },
        (error: HttpErrorResponse) => {
          // Even on error, show neutral message for security
          this.isforgotPWModalVisible = false;
          this.toastr.info(
            this.mrTranslate.transform(
              'Wenn ein Konto mit dieser E-Mail-Adresse existiert, wurde eine E-Mail mit Anweisungen zum Zurücksetzen des Passworts gesendet.'
            ),
            '',
            { timeOut: 8000 }
          );
        }
      );
    }
  }

  isNumeric(value) {
    return /^-?\d+$/.test(value);
  }

  getValidCode(event): void {
    if (this.excode.nativeElement.value.toString().length != 6) {
      this.toastr.error(this.mrTranslate.transform('Bestätigungscode ist ungültig'));
      return;
    }
    this.pcode = this.excode.nativeElement.value;
    if (this.pcode == this.generatedNumber.toString()) {
      this.curSec1 = 300;
      this.isCodeModalVisible = false;
      this.isNewPasswordVisible = true;
      this.doexittimer = true;
    } else {
      this.isCodeModalVisible = false;
      this.excode.nativeElement.value = '';
      this.toastr.error(this.mrTranslate.transform('Bestätigungscode ist ungültig'));
      this.isNewPasswordVisible = true;
    }
  }

  setNewPassword(event): void {
    if (this.exnewpw.nativeElement.value.toString().length < 6) {
      this.toastr.error(this.mrTranslate.transform('Passwort muss mindestens 6 Zeichen lang sein'));
      return;
    }

    this.pw = this.exnewpw.nativeElement.value;

    if (this.pw == this.exnewpwconf.nativeElement.value) {
      this.isNewPasswordVisible = true;

      this.pwsha = shajs('sha256').update(this.pw).digest('hex');

      this.authService.updatepassword(this.pemail, this.userid.toString(), this.pwsha).subscribe((data: any) => {
        if (data.toLowerCase() == 'true') {
          this.isNewPasswordVisible = false;
          this.toastr.success(this.mrTranslate.transform('Passwort wurde geändert'));
        } else {
          this.toastr.error(this.mrTranslate.transform('Leider ist ein Fehler aufgetreten.'));
        }
      });
    } else {
      this.isNewPasswordVisible = true;
      this.exnewpwconf.nativeElement.value = '';
      this.toastr.error(this.mrTranslate.transform('Passwort stimmt nicht überein'));
    }
  }

  startTimer(seconds: number) {
    const time = seconds;
    const timer$ = interval(1000);

    const sub = timer$.subscribe(sec => {
      this.progressbarValue = 100 - (sec * 100) / seconds;
      this._seconds = seconds - sec;
      ((this.tminutes = Math.floor((this._seconds % 3600) / 60)), (this.tseconds = Math.floor(this._seconds % 60)));
      this.dateSec = this.tminutes.toString().padStart(2, '0') + ':' + this.tseconds.toString().padStart(2, '0');
      this.curSec1 = sec;
      if (this.curSec1 === seconds) {
        sub.unsubscribe();
        this.isCodeModalVisible = false;
      }

      if (this.doexittimer) sub.unsubscribe();
    });
  }
}
